<app-modalbase [title]="'Cambiar de soluciones' | translate" [primaryBtnLabel]="'Continuar' | translate"
  [secondaryBtnLabel]="'Cancelar' | translate" [primaryBtnDisabled]="!canContinue()" (close)="close()"
  (secondaryClick)="close()" (primaryClick)="onContinue()">

  <div class="switch-solution-content">
    <p class="modal-subtitle">
      {{ 'Selecciona la solución en la que vas a trabajar' | translate }}
    </p>

    @if (isLoading()) {
    <div class="switch-solution-loader">
      <mat-spinner diameter="40" aria-hidden="true"></mat-spinner>
    </div>
    } @else if (hasError()) {
    <p class="switch-solution-empty">
      {{ 'No pudimos cargar las soluciones. Intenta nuevamente.' | translate }}
    </p>
    } @else if (!solutions().length) {
    <p class="switch-solution-empty">
      {{ 'Este workspace no tiene soluciones habilitadas.' | translate }}
    </p>
    } @else {
    <div class="solution-list">
      @for (solution of solutions(); track solution.key) {
      <app-solution-option [solution]="solution" [selected]="isSelected(solution)"
        (selectSolution)="onSelectSolution($event)" />
      }
    </div>
    }
  </div>

</app-modalbase>
